/** Остались id корневых оверлеев и aria; контент HUD — из React store. */
export const TARGET_ATTACK_DOM = {
  root: 'target-attack-ui',
  pauseRoot: 'target-attack-pause',
  pauseTitle: 'target-attack-pause-title',
  gameOverRoot: 'target-attack-gameover',
  restartBtn: 'target-attack-restart-btn',
} as const;
